import {Injectable,NgModule} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {User} from '../providers/user';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  //constructor(private user: User) {}
  constructor(private user:User) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //let testToken = this.user.cognito.getCurrentUser;
    //let testTt = testToken;
    // Get the auth header from the service.
    //const authHeader = localStorage.getItem("cognitoToken");
    // Clone the request to add the new header.
    const authReq = req.clone({headers: req.headers.set('Authorization', this.getAccessHeader())});

    /*const authReq = req.clone({
      setHeaders:{
        'Authorization': token
      }
    });
    */ 
    // Pass on the cloned request instead of the original request.
    return next.handle(authReq);
    //return next.handle(req);
  }

  getAccessHeader(){
    let usertest = this.user.getUser().signInUserSession.idToken.jwtToken;
    return usertest;
  }
 
};

@NgModule({
    providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
    ]
   })
   export class InterceptorModule { }




// WEBPACK FOOTER //
// ./src/api-service/auth-interceptor.service.ts